import i from "react";
import m from "react-dom";
import f from "@rxfork/r2wc-core";
var u, n = m;
if (process.env.NODE_ENV === "production")
  u = n.createRoot, n.hydrateRoot;
else {
  var c = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  u = function(t, e) {
    c.usingClientEntryPoint = !0;
    try {
      return n.createRoot(t, e);
    } finally {
      c.usingClientEntryPoint = !1;
    }
  };
}
function E(t, e, o) {
  const r = u(t), a = i.createElement(e, o);
  return r.render(a), {
    root: r,
    ReactComponent: e
  };
}
function _({ root: t, ReactComponent: e }, o) {
  const r = i.createElement(e, o);
  t.render(r);
}
function l({ root: t }) {
  t.unmount();
}
function p(t, e = {}) {
  return f(t, e, { mount: E, update: _, unmount: l });
}
export {
  p as default
};
